import api from './api';

export interface Page {
    id: string;
    title: string;
    slug: string;
    content: string;
    type: 'quick-link' | 'support' | 'blog';
    status: 'active' | 'inactive';
    order: number;
    excerpt?: string;
    seoTitle?: string;
    seoDescription?: string;
    coverImageUrl?: string;
    authorName?: string;
    tags?: string[];
    productIds?: string[];
    aiPrompt?: string;
    publishedAt?: any;
    totalViews?: number;
    totalUniqueViews?: number;
    webViews?: number;
    webUniqueViews?: number;
    createdAt?: any;
    updatedAt?: any;
}

export interface PageFormData {
    title: string;
    slug?: string;
    content: string;
    type: 'quick-link' | 'support' | 'blog';
    status: 'active' | 'inactive';
    order: number;
    excerpt?: string;
    seoTitle?: string;
    seoDescription?: string;
    coverImageUrl?: string;
    authorName?: string;
    tags?: string[];
    productIds?: string[];
    aiPrompt?: string;
}

export const pagesApi = {
    async getAll(): Promise<Page[]> {
        const response = await api.get('/admin/pages');
        return response.data;
    },

    async getById(id: string): Promise<Page> {
        const response = await api.get(`/admin/pages/${id}`);
        return response.data;
    },

    async create(data: PageFormData): Promise<Page> {
        const response = await api.post('/admin/pages', data);
        return response.data;
    },

    async update(id: string, data: Partial<PageFormData>): Promise<Page> {
        const response = await api.put(`/admin/pages/${id}`, data);
        return response.data;
    },

    async remove(id: string): Promise<void> {
        await api.delete(`/admin/pages/${id}`);
    },
};
